import { useEffect, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    Col,
    FormGroup,
    Input,
    InputGroup,
    Label,
    Row
} from "reactstrap";
import { toast } from "react-toastify";
import {
    getMaxGroups,
    updateMaxGroups
} from "../Services/AppSettingsService";


const AppSettingsPage = () => {

    const [maxGroups, setMaxGroups] = useState(5);

    useEffect(() => {
        load();
    }, []);

    const load = async () => {
        const value = await getMaxGroups();
        setMaxGroups(value);
    };

    const save = async () => {

        await updateMaxGroups(maxGroups);

        toast.success(
            "Settings updated successfully."
        );
    };

    return (



                <FormGroup>
                   
                    <Label
                        style={{
                            fontWeight: 600,
                            marginBottom: "8px",
                        }}
                    >
                        Maximum Free Groups Per User
                    </Label>
<InputGroup style={{ maxWidth: "350px" }} className="Search-input">
    <Input
        type="number"
        min={1}
        value={maxGroups}
        onChange={(e) => setMaxGroups(Number(e.target.value))}
        placeholder="Enter maximum free groups"
    />

    <Button
        color="primary"
        onClick={save}
    >
        💾 Save
    </Button>
</InputGroup>
                </FormGroup>
       

       


    );

};

export default AppSettingsPage;